/* CUSTOM 2026-07-16 : barre "Ajouter au panier" sticky, mobile uniquement.
   Reversible : ce fichier est autonome, il suffit de le retirer (+ le .css + le snippet + son render). */

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('.sticky-add-to-cart__price');
        this.button = this.querySelector('.sticky-add-to-cart__button');
        // Premier <product-info> de la page = la fiche produit principale.
        this.productInfo = document.querySelector('product-info');

        if (!this.button || !this.productInfo) return;

        this.button.addEventListener('click', this.onClick.bind(this));

        // Dawn re-fetche et remplace une partie du bloc d'achat a chaque changement de variante
        // (prix, bouton...). On observe le conteneur stable pour resynchroniser la barre a chaque fois.
        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(this.productInfo, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });

        this.sync();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      getRealButton() {
        return this.productInfo ? this.productInfo.querySelector('.product-form__submit') : null;
      }

      sync() {
        const realButton = this.getRealButton();
        if (!realButton) return;

        // (Re)brancher l'observateur de visibilite si le vrai bouton a ete remplace
        // (changement de variante -> Dawn reconstruit ce bloc).
        if (realButton !== this.observedButton) {
          this.intersectionObserver?.disconnect();
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.hidden = entries[0].isIntersecting;
            },
            { threshold: 0 }
          );
          this.intersectionObserver.observe(realButton);
          this.observedButton = realButton;
        }

        // Etat actif / rupture de stock, calque sur le vrai bouton.
        this.button.disabled = realButton.disabled;
        const realLabel = realButton.querySelector('span');
        const label = this.button.querySelector('span');
        if (realLabel && label) label.textContent = realLabel.textContent.trim();

        // Prix affiche, calque sur le bloc prix reel (gere le cas promo / prix barre).
        const priceRoot = this.productInfo.querySelector('.price--large');
        if (priceRoot && this.priceEl) {
          const onSale = priceRoot.classList.contains('price--on-sale');
          const selector = onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
          const priceNode = priceRoot.querySelector(selector);
          if (priceNode) this.priceEl.textContent = priceNode.textContent.trim();
        }
      }

      onClick() {
        const realButton = this.getRealButton();
        if (!realButton) return;

        if (realButton.disabled) {
          // Pas de variante disponible pour la combinaison actuelle : on guide le client
          // vers le selecteur de taille/variante plutot que de ne rien faire.
          const variantSelects = this.productInfo.querySelector('variant-selects');
          const target = variantSelects || realButton;
          const headerOffset =
            parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 60;
          const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - this.offsetHeight - 16;
          window.scrollTo({ top, behavior: 'smooth' });
          return;
        }

        // Reutilise integralement la logique panier existante (spinner, drawer, erreurs...).
        realButton.click();
      }
    }
  );
}
